import { useIntl } from 'react-intl';
import { AsideMenuItem } from './AsideMenuItem';
import { useSelector } from 'react-redux';
import { authUserSelector } from '../../../../app/modules/auth';
import { authorizedMarketingDashboardUsers } from '../../../../app/modules/acquisition';
import authorizedB2COrdersUsers from '../../../../app/modules/orders/constants/authorizedB2COrdersUsers';
import { authorizedVixieesLeadsUsers } from '../../../../app/modules/vixiees-leads';

export function AsideMenuBusiness() {
  const intl = useIntl();
  const authUser = useSelector(authUserSelector);
  const isTachoUser = !!authUser?.groups?.find(
    (aGroup) => aGroup.name === 'Tacho'
  );
  const isBusinessUser = !isTachoUser;

  return isBusinessUser ? (
    <>
      <h5 className="menu-title text-light pb-4 mb-0 mt-2 ms-6">
        {intl.formatMessage({ id: 'menu.business' })}
      </h5>
      <AsideMenuItem
        to={`/partner-stores`}
        title={intl.formatMessage({ id: 'menu.partnerStores' })}
        fontIcon="fa-store"
      />
      {authorizedB2COrdersUsers.includes(authUser?.email) && (
        <AsideMenuItem
          to={`/operation-orders`}
          title={intl.formatMessage({ id: 'menu.operationOrders' })}
          fontIcon="fa-boxes"
        />
      )}
      {authorizedMarketingDashboardUsers.includes(authUser?.email) && (
        <AsideMenuItem
          to="/acquisition-dashboard"
          title={intl.formatMessage({ id: 'menu.marketingDashboard' })}
          fontIcon="fa-chart-line"
        />
      )}
      {authorizedVixieesLeadsUsers.includes(authUser?.email) && (
        <AsideMenuItem
          to="/vixiees-leads"
          title={intl.formatMessage({ id: 'menu.vixieesLeads' })}
          fontIcon="fa-filter"
        />
      )}
      <div className="menu-item">
        <div className="menu-content">
          <div className="separator mx-1 my-4"></div>
        </div>
      </div>
    </>
  ) : (
    <></>
  );
}
